import React, { useState } from 'react';
import RankList from './Rank/RankList';
import RankManipulation from './Rank/RankManipulation';
import CollegeStatus from './Rank/Charts/CollegeStatus';
import BranchStatus from './Rank/Charts/BranchStatus';
import RankInsertion from './Rank/RankInsertion/RankInsertion';

function RankServices() {
    const [activeTab, setActiveTab] = useState('ranklist');
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
                    <div style={{ maxWidth: '350px' }} className='chart-container'>
                        <CollegeStatus />
                    </div>
                    <div style={{ maxWidth: '350px' }} className='chart-container'>
                        <BranchStatus />
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                    <div className="tabs">
                        <button
                            className={`tab-btn ${activeTab === 'ranklist' ? 'active' : ''}`}
                            onClick={() => setActiveTab('ranklist')}
                        >
                            Rank List
                        </button>
                        <button
                            className={`tab-btn ${activeTab === 'rankInsert' ? 'active' : ''}`}
                            onClick={() => setActiveTab('rankInsert')}
                        >
                            Rank Insertion
                        </button>
                        {/* <button
                            className={`tab-btn ${activeTab === 'rankInsert' ? 'active' : ''}`}
                            onClick={() => setActiveTab('RankInsert')}
                        >
                            Rank Insertion
                        </button> */}
                    </div>
                </div>
                {activeTab === 'ranklist' && (
                    <div className='app-service-container'>
                        <RankList />
                    </div>
                )}
                {activeTab === 'rankInsert' && (
                    <div className='app-service-container'>
                        <RankInsertion />
                    </div>
                )}
                {/* {activeTab === 'rankInsert' && (
                    <div className='app-service-container'>
                        <RankManipulation />
                    </div>
                )} */}
            </div>
        </div>
    );
}

export default RankServices;